import { render, staticRenderFns } from "./PublicRoleDeclaration.vue?vue&type=template&id=7f55c92c&"
import script from "./PublicRoleDeclaration.vue?vue&type=script&lang=ts&"
export * from "./PublicRoleDeclaration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports